module.exports = __webpack_public_path__ + "static/img/m_global_flow_step1@3x.012ab4d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/m_global_flow_step1@3x.png
// module id = auw9
// module chunks = 1